import { Object3D } from 'three';

import {
  registerOnHover,
  deregisterOnHover,
} from './hover';

import {
  deregisterObject,
  intersections,
  registerObject,
} from './raycaster';

import {
  setCursor,
  unsetCursor,
  Cursor,
} from './cursor';

// returns true if it wants the click event to propagate
type DragStartCallback = (event: MouseEvent) => boolean | void;
type DragCallback = (firstEvent: MouseEvent, currentEvent: MouseEvent) => boolean | void;
type DragEndCallback = (firstEvent: MouseEvent, currentEvent: MouseEvent) => boolean | void;

interface DragCallbacks {
  dragStart: DragStartCallback;
  drag: DragCallback;
  dragEnd: DragEndCallback;
}

const onDragCallbacks: Record<string, DragCallbacks> = {};

let currentlyDraggedObjectIds: string[] = [];
let mouseDownEvent: MouseEvent | undefined;

document.addEventListener('mousedown', onDragStart, false);
function onDragStart(event: MouseEvent) {
  // event.preventDefault();
  // event.stopPropagation();

  mouseDownEvent = event;
  for (const intersection of intersections) {
    const { uuid } = intersection.object;
    const callbacks = onDragCallbacks[uuid];
    if (callbacks) {
      const propagateEvent = callbacks.dragStart(event);
      currentlyDraggedObjectIds.push(uuid);
      if (!propagateEvent) return;
    }
  }
}

document.addEventListener('mousemove', onDrag);
function onDrag(event: MouseEvent) {
  if (mouseDownEvent === undefined) return;

  // event.preventDefault();
  // event.stopPropagation();

  currentlyDraggedObjectIds.forEach((uuid) => {
    const callbacks = onDragCallbacks[uuid];
    if (callbacks && mouseDownEvent) callbacks.drag(mouseDownEvent, event);
  });
}

document.addEventListener('mouseup', onDragEnd);
function onDragEnd(event: MouseEvent) {
  if (mouseDownEvent === undefined) return;

  // event.preventDefault();
  // event.stopPropagation();

  currentlyDraggedObjectIds.forEach((uuid) => {
    const callbacks = onDragCallbacks[uuid];
    if (callbacks && mouseDownEvent) callbacks.dragEnd(mouseDownEvent, event);
  });

  currentlyDraggedObjectIds = [];
}

export function registerOnDrag(
  obj: Object3D,
  dragStart: DragStartCallback,
  drag: DragCallback,
  dragEnd: DragEndCallback,
  hoverCursor: Cursor = Cursor.grab,
  dragCursor: Cursor = Cursor.grabbing,
) {
  if (!onDragCallbacks[obj.uuid]) {
    registerObject(obj);
    onDragCallbacks[obj.uuid] = {
      dragStart: (event) => {
        setCursor(dragCursor);
        dragStart(event);
      },
      drag,
      dragEnd: (startEvent, event) => {
        unsetCursor();
        dragEnd(startEvent, event);
      },
    };
  }

  registerOnHover(
    obj,
    () => setCursor(hoverCursor),
    unsetCursor,
  );
}

export function deregisterOnDrag(obj: Object3D) {
  delete onDragCallbacks[obj.uuid]
  deregisterObject(obj);
  deregisterOnHover(obj);
}
